import { render, staticRenderFns } from "./ShippingMethod.vue?vue&type=template&id=ee8b4d36&scoped=true&"
import script from "./ShippingMethod.vue?vue&type=script&lang=js&"
export * from "./ShippingMethod.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethod.vue?vue&type=style&index=0&id=ee8b4d36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8b4d36",
  null
  
)

export default component.exports